import { render, staticRenderFns } from "./AiCommonDepartmentFixedPhraseSelector.vue?vue&type=template&id=14871d0c&scoped=true&"
import script from "./AiCommonDepartmentFixedPhraseSelector.vue?vue&type=script&lang=ts&"
export * from "./AiCommonDepartmentFixedPhraseSelector.vue?vue&type=script&lang=ts&"
import style0 from "./AiCommonDepartmentFixedPhraseSelector.vue?vue&type=style&index=0&id=14871d0c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14871d0c",
  null
  
)

export default component.exports